/* tslint:disable */
/* eslint-disable */
export enum GraphGrouping {
  BySession = 0,
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
  Yearly = 4,
  ByStaffMember = 5,
  ByTrial = 6
}
